import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";

function ErrorPage() {
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
        textAlign: "center",
      }}
    >
      <Box sx={{ fontSize: 100, color: "#d32f2f" }}>
        <ErrorOutline />
      </Box>
      <Typography variant="h4" sx={{ fontWeight: "bold", color: "#333" }}>
        Something went wrong!
      </Typography>
      <Typography variant="h6" sx={{ marginBottom: 3, color: "#555" }}>
        We couldn't process your request. Please try again later.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{ padding: "10px 20px", fontSize: "16px" }}
        onClick={() => window.location.reload()}
      >
        Retry
      </Button>
    </Container>
  );
}

export default ErrorPage;
